export default "__VITE_ASSET__D7P7T8$C__"